import { render, staticRenderFns } from "./EducationalItemReview.vue?vue&type=template&id=a0337a3a&scoped=true&"
import script from "./EducationalItemReview.vue?vue&type=script&lang=js&"
export * from "./EducationalItemReview.vue?vue&type=script&lang=js&"
import style0 from "./EducationalItemReview.vue?vue&type=style&index=0&id=a0337a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0337a3a",
  null
  
)

export default component.exports